module.exports = __webpack_public_path__ + "static/media/slide_1.7224d2e9.jpg";